import { useEffect, useState } from 'react';
import { createRoot } from 'react-dom/client';
import '../assets/css/styles.css';
import logo from '../assets/img/logo.png';
import separador from '../assets/img/separador.png';
import env from '../env/env'
import { IniciarSesion } from '../funciones/sesion';
import { typeWriter } from '../funciones/typeWriter.js';
import Dialog from '../components/dialog.jsx';
import Progress from '../components/progress.jsx';



function isesion() {
    let txtEmail = document.getElementById("txtEmail"),
        txtContrasena = document.getElementById("txtContrasena");
    createRoot(document.getElementById("dg")).render(<Progress />)
    IniciarSesion(txtEmail.value, txtContrasena.value).then(data => {
        createRoot(document.getElementById("dg")).unmount(<Progress />)
        respuesta(data.email, data);
    });
}



function respuesta(respuesta, data) {
    const velocidad = 100;
    let mensaje = "";
    switch (respuesta) {
        case "inexistente":
            mensaje = "¡Me parece que aun no tienes tu carta de aceptación, anda, registrate y vuelve despues!";
            break;

        case "existente":
            mensaje = "¡Me parece que tu contraseña es incorrecta, intenta nuevamente!";
            break;

        default:
            localStorage.setItem('session', JSON.stringify(data));
            window.location.replace('/#/Inicio');
            return;
    }
    createRoot(document.getElementById("dg")).render(<Dialog />)

    setTimeout(() => {
        const elemento = document.getElementById('mensaje');
        typeWriter(elemento, mensaje, velocidad, function () {
            createRoot(document.getElementById("dg")).unmount(<Dialog />)
        })
    }, 300);

}

function Sesion(props) {
    useEffect(() => {

    });
    return (
        <div className="Sesion">
            <header>

            </header>
            <div id="dg">

            </div>
            <div class="container center-v">

                <div class="login">
                 
                    <div>
                        <div class="logo">
                            <img src={logo} class="img-responsive "></img>
                        </div>

                        <div class="separador">
                            <img src={separador} class="img-responsive"></img>
                        </div>
                    </div>

                    <div>
                        <input id="txtEmail" type='email' class="form-control" placeholder="Email"></input>
                        <input id="txtContrasena" type='password' class="form-control" placeholder="Contraseña"></input>
                    </div>
                    <div class="separador">
                        <img src={separador} class="img-responsive"></img>
                    </div>

                    <div>
                        <button class="form-control" onClick={isesion}>CAPUT DRACONIS</button>
                    </div>
                    <div class="top-buffer">
                        <a href="/#/Recupera"><p class="enlaces"><small>Harry, ¿Olvidaste tu contraseña?</small></p></a>
                        <a href="/#/Registro"><p class="enlaces"><small>¿Quieres ser parte de esta gran familia mágica? <br></br> Regístrate aquí</small></p></a>
                        <a href="/#/Menu"><p class="enlaces"><small>¿Tienes hambre y no puedes esperar a registrarte? <br></br> Mira nuestro menú aquí</small></p></a>
                    </div>

                </div>
            </div>

        </div>);
}

export default Sesion;